import { Button, SelectChangeEvent } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import ConfigurationHeader from '../../components/heading/ConfigurationHeader'
import Input, { CameraImage, DashboardCheckbox, DashboardSelect, InputList } from '../../components/Input/Input'
import { configurationAttributeType, newConfigurationNames, authConfigurationValuesTypes, loginBannerState } from '../../types'
import { popupType } from '../../types/types'
import { convertValuesToConfig, createValidation, doFinalConfigSubmit, getMetaDataConfig, getNewConfiguration, overWriteConfig, postConfiguration, updateConfiguration } from '../../services/uiConfigService'
import * as yup from 'yup'
import './AuthConfiguration.css'
import store from '../../stateManagement/store'
import { GenericPopUp } from '../../components/popup/genericPopUp'
import * as Sentry from "@sentry/react";
import { IndentWrapper } from '../orderConfiguration/OrderConfiguration'
import QuestionHeading from '../../components/heading/QuestionHeading'
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions'
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes'
import { authDefaultValues } from '../defaultConfigurations/authConfigDefaultValues'
import { deepClone } from '@mui/x-data-grid/utils/utils'
import { uploadImages } from '../../services/bannerServices'
import ConfigComparePopup from '../../components/popup/ConfigComparePopup'
import ImportConfig from '../../components/importConfig/ImportConfig'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons'



const AuthConfiguration = (props:{showBackButton?:boolean}) => {
    const [authConfig, setAuthConfig] = useState<configurationAttributeType[]>([]);
    const [values, setValues] = useState<authConfigurationValuesTypes>(deepClone(authDefaultValues))
    const [authValidationsSchema, setAuthValidationSchema] = useState({})
    const [openGenericModal, setOpenGenericModal] = useState(false);
    const [popupType, setPopupType] = useState<popupType>("Alert");
    const [genericMessage, setGenericMessage] = useState("");

    const [loginBanners,setLoginBanners] = useState<loginBannerState[]>([...authDefaultValues.loginBanners.value]);

    const [showConfigPopup,setShowConfigPopup] = useState<boolean>(false);
    const curConfigRef = useRef<{[key:string]:any[]}>({});
    const newConfigRef = useRef<{[key:string]:any[]}>({});


    const handleLoginFileChange = (index: number, selectedFile: File) => {
        const updatedUploads = [...loginBanners];
        updatedUploads[index] = selectedFile;
        setLoginBanners(updatedUploads);
      };
    const handleLoginImageRemove = (index: number) => {
        if(values.loginBanners.value[index]){//reset values array
            const newValues = {...values};
            values.loginBanners.value[index] = "";
            setValues(newValues);
        }
        const updatedUploads = [...loginBanners];
        updatedUploads[index] = "";
        setLoginBanners(updatedUploads);
    }
    const openPopup = (message: string, type: popupType) => {
        setPopupType(type)
        setGenericMessage(message)
        setOpenGenericModal(true)
    }
    const getAuthConfiguration = async () => {
        try {
            const resp = await getNewConfiguration('authentication_configuration');
            const customer_config: configurationAttributeType[] = resp?.domainValues;
            curConfigRef.current.authentication_configuration = customer_config;
            
            setAuthConfig([...customer_config])
        } catch (err) {
            // Sentry.captureException(err);
        }
    }
    useEffect(() => {
        getAuthConfiguration();
    }, [])


    const saveConfiguration = async (preview?: boolean) => {
            try {
                const isLoginBannerAdded = loginBanners.find((loginBanner: loginBannerState) => loginBanner!=="");
                if(isLoginBannerAdded){
                    const imagesFormData = new FormData();
                    for(let bannerIdx=0;bannerIdx<loginBanners.length;bannerIdx++){
                        if(loginBanners[bannerIdx]){
                            imagesFormData.append("files",loginBanners[bannerIdx]);
                        }
                    }
                    const blobUrls = imagesFormData.has("files")
                        ? await uploadImages(imagesFormData)
                        : [];
                    if (!Array.isArray(blobUrls)) {
                        openPopup("Something went wrong while generating blob keys","Error");
                        return;
                    }
                    let blobIdx = 0;
                    for(let bannerIdx=0;bannerIdx<values.loginBanners.value.length;bannerIdx++){
                        if(loginBanners[bannerIdx]){
                            values.loginBanners.value[bannerIdx] = blobUrls[blobIdx++];
                        }
                    }
                    setLoginBanners(["","",""]);
                    setValues({...values});
                }
                const authSchema = yup.object({ ...authValidationsSchema })
                const validationObject:any = {};
                Object.keys(values).forEach(key=>{
                    validationObject[key] = values[key].value;
                })
                // await authSchema.validate(validationObject)
                const convertedVals = convertValuesToConfig(values, authConfig);
                // newConfigRef.current = [convertedVals];
                newConfigRef.current.authentication_configuration = convertedVals;
                setShowConfigPopup(true);
            } catch (err) {
                // Sentry.captureException(err);
                console.log("err===", err)
                if (err instanceof Error)
                    openPopup("Validation Error occured : " + err?.message, 'Error')
            }
        
    }
   
    const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }

    const handleListValueChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,index:number) => {
        const keyName = e.target.name;
        const updatedList=values?.[keyName].value
        updatedList[index]=e.target.value;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:updatedList, isValueUpdated:true} 
        })
    }

    const handleSelectValueChange = (e: SelectChangeEvent<unknown>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.value, isValueUpdated:true} 
        })
    }

    const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        setValues({
            ...values,
            [keyName]: {...values[keyName], value:e.target.checked, isValueUpdated:true} 
        })
    }

    const setAuthConfigValues = () => {
        try {
            if (authConfig.length) {
                const result = { ...values } 
                const resValidations = {} as { [key: string]: ReturnType<typeof createValidation> }
                authConfig.forEach((attr) => {
                    resValidations[attr.name] = createValidation(attr)
                    result[attr.name] = attr
                })
                setValues({ ...result as authConfigurationValuesTypes });
                setAuthValidationSchema({ ...resValidations })
            }
        } catch (err) {
            // Sentry.captureException(err);
        }
    }

    useEffect(() => {
        setAuthConfigValues();
    }, [authConfig])


  const importConfiguration = async (importedConfig:any)=>{
    const newConfigs = await overWriteConfig(importedConfig, {
        // authentication_configuration:["loginType","subheading","deviceUID","instantRegistration","loginBanners"]
        authentication_configuration:"importAll"
    })
    newConfigs.forEach((item) => {
        newConfigRef.current[item.domainType] = item.domainValues;
    });
    setShowConfigPopup(true);
  }

    const onConfigComparatorSuccess = async () => {
        await doFinalConfigSubmit("authentication_configuration", newConfigRef.current.authentication_configuration, curConfigRef);
        getAuthConfiguration();
    }
  const [importConfigState,setImportConfigState] = useState(false);


    return (
        <div className="auth_config_container">
            <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={['authentication_configuration']} importConfigCallback={importConfiguration} />
            <ConfigurationHeader importConfiguration={()=>{setImportConfigState(true)}} heading={"Login page Configuration"} showBackButton={props.showBackButton} saveConfiguration={() => saveConfiguration(false)}/>
            <div className="config_form_container">
            

            <IndentWrapper indent={1}>
                <QuestionHeading>
                    loginType
                </QuestionHeading>
                <div className="answer_container">
                    <DashboardSelect onChange={handleSelectValueChange} value={values.loginType.value} name="loginType" options={values.loginType.possibleVals} selectLableId='Select default order unit' />
                </div>
            </IndentWrapper>

            <IndentWrapper indent={1}>
                <QuestionHeading>
                    otpProvider
                </QuestionHeading>
                <div className="answer_container">
                    <DashboardSelect onChange={handleSelectValueChange} value={values.otpProvider.value} name="otpProvider" options={values.otpProvider.possibleVals} selectLableId='otpProvider' />
                </div>
            </IndentWrapper>

                {values.otpProvider.value === 'vonage' &&
                    <IndentWrapper indent={2}>
                        <InputList values={values} question="otpDisclaimer" setValues={setValues} configName="otpDisclaimer" />
                    </IndentWrapper>
                }
                
            <IndentWrapper indent={1}>
                <QuestionHeading>
                subheading
                </QuestionHeading>
                <div className="answer_container">
                    <Input value={values.subheading.value} onChange={handleValueChange} name="subheading" />
                </div>
            </IndentWrapper>

            <IndentWrapper indent={1}>
                <QuestionHeading>
                otpType
                </QuestionHeading>
                <div className="answer_container">
                    <Input value={values?.otpType?.value} onChange={handleValueChange} name="otpType" />
                </div>
            </IndentWrapper>

            <IndentWrapper indent={0}>
                    <QuestionHeading>
                    what will be the maximum length of phone number?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.phoneNumberMaximumLength.value} onChange={handleValueChange} name="phoneNumberMaximumLength" />
                    </div>
                </IndentWrapper>

            <IndentWrapper indent={0}>
                    <QuestionHeading>
                    what will be the Minimum length of phone number?
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.phoneNumberMinimumLength.value} onChange={handleValueChange} name="phoneNumberMinimumLength" />
                    </div>
            </IndentWrapper>

            <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Hint text for phone login text field
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.phoneLoginHintText.value} onChange={handleValueChange} name="phoneLoginHintText" />
                    </div>
            </IndentWrapper>
            <IndentWrapper indent={0}>
                    <QuestionHeading>
                    Hint text for outlet login text field
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.outletLoginHintText.value} onChange={handleValueChange} name="outletLoginHintText" />
                    </div>
            </IndentWrapper>

            <IndentWrapper indent={0}>
                    <QuestionHeading>
                    logoutMessage
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.logoutMessage.value} onChange={handleValueChange} name="logoutMessage" />
                    </div>
            </IndentWrapper>

            <IndentWrapper indent={0}>
                    <QuestionHeading>
                    otpTimer
                    </QuestionHeading>
                    <div className="answer_container">
                        <Input value={values.otpTimer.value} onChange={handleValueChange} name="otpTimer" />
                    </div>
            </IndentWrapper>

            <IndentWrapper indent={1}>
                <QuestionHeading>
                deviceUID
                </QuestionHeading>
                <div className="answer_container">
                    <DashboardCheckbox onChange={handleCheckChange} checked={values.deviceUID.value} name="deviceUID" label="Yes" />
                </div>
            </IndentWrapper>

            <IndentWrapper indent={1}>
                <QuestionHeading>
                instantRegistration
                </QuestionHeading>
                <div className="answer_container">
                    <DashboardCheckbox onChange={handleCheckChange} checked={values.instantRegistration.value} name="instantRegistration" label="Yes" />
                </div>
            </IndentWrapper>

            <IndentWrapper indent={1}>
                <QuestionHeading>
                termsChecked
                </QuestionHeading>
                <div className="answer_container">
                    <DashboardCheckbox onChange={handleCheckChange} checked={values.termsChecked.value} name="termsChecked" label="Yes" />
                </div>
            </IndentWrapper>

            <IndentWrapper indent={1}>
                <QuestionHeading>
                    Upload the Login banner
                </QuestionHeading>
                <IndentWrapper indent={1}>
                    <span className="auth_configuration_login_banners_resolution">*The image resolution should be 720x540</span>
                    <div className="auth_configuration_login_banners">
                        {loginBanners.map((loginBannerImage: loginBannerState,index: number) => {
                            return (<div key={index} className="auth_configuration_login_banner_container">
                                        <CameraImage image={loginBannerImage as string} width={"10rem"} height={"6.5rem"} validHeight={540} validWidth={720} name="loginBanner" setImage={(selectedFile) => handleLoginFileChange(index, selectedFile)} currImage={values.loginBanners.value[index]} uploadText="Login Banner" />
                                        <Button style={{ fontSize: "0.7rem" }} variant="contained" disabled={!loginBannerImage && !values.loginBanners.value[index]} onClick={() => {
                                            handleLoginImageRemove(index);
                                        }}>Remove Image</Button>
                                    </div>)
                        })}
                    </div>
                </IndentWrapper>
            </IndentWrapper>
            
            </div>
            <GenericPopUp message={genericMessage}
                type={popupType}
                openGenericModal={openGenericModal}
                setOpenGenericModal={setOpenGenericModal} />

            <ConfigComparePopup message="Are you sure want to update the config" showConfigPopup={showConfigPopup} setShowConfigPopup={setShowConfigPopup} curConfig={curConfigRef.current} newConfig={newConfigRef.current} onSuccess={onConfigComparatorSuccess} />
        </div>

    )
}

export default AuthConfiguration